
<template>
  <div>
    <div style="margin-top: 15px;">
      <el-input placeholder="请输入搜索内容" v-model="searchValue" class="input-with-select">
        <el-select v-model="select" slot="prepend" placeholder="请选择" clearable>
          <el-option label="用户邮箱" value="likeAll_userMail"></el-option>
          <el-option label="姓名" value="likeAll_userName"></el-option>
          <el-option label="部门" value="likeAll_department"></el-option>
          <el-option label="上级名称" value="likeAll_superior"></el-option>
        </el-select>
      </el-input>
      <el-select v-model="searchBar.role" clearable placeholder="请选择角色" filterable @change="getSearchDate">
        <el-option label="Support" value="Support"></el-option>
        <el-option label="Seller" value="Seller"></el-option>
        <el-option label="SuadMin" value="SuadMin"></el-option>
        <el-option label="Admin" value="Admin"></el-option>
      </el-select>
      <el-select v-model="searchBar.status" clearable placeholder="请选择状态" filterable @change="getSearchDate">
        <el-option label="正常" value="1"></el-option>
        <el-option label="冻结" value="2"></el-option>
      </el-select>
      <el-button slot="append" icon="el-icon-search" @click="getSearchDate"></el-button>
    </div>

    <div class="userInfo">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column label="姓名" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户邮箱" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.userMail }}</span>
          </template>
        </el-table-column>
        <el-table-column label="部门" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.department }}</span>
          </template>
        </el-table-column>
        <el-table-column label="上级名称" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.superior }}</span>
          </template>
        </el-table-column>
        <el-table-column label="账户是否冻结" width="auto">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1" style="margin-left: 10px">正常</span>
            <span v-else style="margin-left: 10px">冻结</span>
          </template>
        </el-table-column>
        <el-table-column label="角色" width="auto">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.role }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot="header">
            <el-button type="primary" size="mini" @click="AddDialogVisible = true">新增</el-button>
          </template>
          <template slot-scope="scope">
            <el-button size="mini" @click="EditList(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row.userId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 添加分页器 -->
      <div class="block">
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="size"
            :page-sizes="[5, 10, 20,30,50,60,70,100]"
            layout="sizes,prev, pager, next, jumper"
            :total="total">
       </el-pagination>
      </div>

      <!-- 新增的对话框 -->
      <el-dialog title="用户信息管理表" :visible.sync="AddDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="addForm">
          <el-form-item label="姓名">
            <el-input v-model="addForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="用户邮箱">
            <el-input v-model="addForm.userMail"></el-input>
          </el-form-item>
          <el-form-item label="账户密码">
            <el-input v-model="addForm.userPassword" show-password autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input v-model="addForm.department"></el-input>
          </el-form-item>
          <el-form-item label="上级名称">
            <el-input v-model="addForm.superior"></el-input>
          </el-form-item>
          <el-form-item label="账户是否冻结">
            <el-select v-model="addForm.status" placeholder="请选择状态">
              <el-option label="正常" value="1"></el-option>
              <el-option label="冻结" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="addForm.role" placeholder="请选择角色">
              <el-option label="Support" value="Support"></el-option>
              <el-option label="Seller" value="Seller"></el-option>
              <el-option label="Admin" value="Admin"></el-option>
              <el-option label="SuadMin" value="SuadMin"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AddDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑的对话框 -->
      <el-dialog title="用户信息管理表" :visible.sync="editDialogVisible" width="30%" center>
        <el-form :label-position="labelPosition" label-width="80px" :model="editForm">
          <el-form-item label="姓名">
            <el-input v-model="editForm.userName"></el-input>
          </el-form-item>
          <el-form-item label="用户邮箱">
            <el-input v-model="editForm.userMail" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="账户密码">
            <el-input v-model="editForm.userPassword" show-password autocomplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="部门">
            <el-input v-model="editForm.department"></el-input>
          </el-form-item>
          <el-form-item label="上级名称">
            <el-input v-model="editForm.superior" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="账户是否冻结">
            <el-select v-model="editForm.status" placeholder="请选择角色">
              <el-option label="正常" value="1"></el-option>
              <el-option label="冻结" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="editForm.role" placeholder="请选择">
              <el-option label="Support" value="Support"></el-option>
              <el-option label="Seller" value="Seller"></el-option>
              <el-option label="Admin" value="Admin"></el-option>
              <el-option label="SuadMin" value="SuadMin"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEdit()">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiAddUserList,
  apiEditUserList,
  apiDeleteUserList,
  apiUserSearch,
} from "../../api/userInfo";

export default {
  data() {
    return {
      //输入框
      searchBar:{
        role:'',
        status:''
      },
      searchValue:'',
      select:'',
      searchDate: {},
      AddDialogVisible: false,
      editDialogVisible: false,
      labelPosition: "right",
      //新增表单数据：
      addForm: {},
      //编辑表单数据：
      editForm: {},
      //分页器数据
      currentPage: 1, //默认第一页 当前页
       size: 10,
      total:0,//总条数
      formLabelAlign: {
        name: "",
        region: "",
        type: "",
      },
      id: "",
      //表格绑定的数据
      tableData: [],
    };
  },
  methods: {
    handleSizeChange(size) {
      this.size = size;
      this.getSearchDate(false);
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getSearchDate(false);
    },


    //点击确定按钮新增数据
    submitAdd() {
      apiAddUserList(this.addForm).then((res) => {
        if (res.data.code === 200) {
          this.$message.success(res.data.message);
          this.AddDialogVisible = false;
          this.addForm = {};
          this.getSearchDate(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },

    //点击编辑回传数据
    //修改表单数据 双向修改改成深拷贝
    EditList(data) {
      this.editDialogVisible = true;
      this.editForm = JSON.parse(JSON.stringify(data));
    },
    //点击编辑按钮修改数据
    submitEdit() {
      apiEditUserList(this.editForm.userId,this.editForm).then((res) => {
        if (res.data.code === 200) {
          this.editDialogVisible = false;
          this.editForm = {};
          this.$message.success(res.data.message);
          this.getSearchDate(false);
        } else {
          this.$message.warning(res.data.message);
          return false;
        }
      });
    },

    //删除数据
    handleDelete(id) {
      // 提示用户是否删除
       this.$confirm('是否要删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDeleteUserList(id).then((res) => {
            if (res.data.code === 200) {
              this.getSearchDate(false);
              this.$message.success(res.data.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    // 多条件搜索
    getSearchDate(boolean){
      delete this.searchBar.likeAll_userMail;
      delete this.searchBar.likeAll_userName;
      delete this.searchBar.likeAll_department;
      delete this.searchBar.likeAll_superior;
      if (!(this.common.isBlank(this.select))) {
        this.$set(this.searchBar,this.select,this.searchValue)
      }
      this.searchBar = this.common.clearNull(this.searchBar);
      this.currentPage = boolean ? 1 : this.currentPage;
      apiUserSearch({
        page: this.currentPage,
        size: this.size,
        q: JSON.stringify(this.searchBar),
        sort: "userId",
        direction: "DESC",
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.content;
          this.total = res.data.data.totalElements;
          if (boolean) {
            this.$message.success(res.data.message);
          }
        }
      });
    },

  },

  created() {
    this.getSearchDate(true);
  },

};
</script>
<style lang="less">
.el-select .el-input {
  width: 130px;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
</style>

<style lang='less' scoped>
.el-input-group {
  margin-left: 30px;
  width: 500px;
}

.userInfo {
  padding: 15px 30px 50px;
  .el-pagination {
    padding: 32px 0px;
  }
}
</style>